import { notifySessionUnauthorized } from '../auth/sessionEvents';

const AUTH_STORAGE_KEY = 'intellicare_auth';
const BUSINESS_STORAGE_KEY = 'intellicare_business_context';

type BusinessSelection = {
  activeTenantId?: string | null;
  activeEntityId?: string | null;
  activeConfigId?: string | null;
};

/** Exported for axios (`services/api.ts`) so session calls send the same JWT as `apiFetch`. */
export function readAuthToken(): string {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) return '';
    const data = JSON.parse(raw) as { token?: string };
    return data?.token ?? '';
  } catch {
    return '';
  }
}

function readToken(): string {
  return readAuthToken();
}

function readBusinessSelection(): BusinessSelection {
  try {
    const raw = localStorage.getItem(BUSINESS_STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as BusinessSelection;
  } catch {
    return {};
  }
}

export function buildApiHeaders(base?: HeadersInit): HeadersInit {
  const headers = new Headers(base ?? {});
  const token = readToken();
  if (token) headers.set('Authorization', `Bearer ${token}`);

  const ctx = readBusinessSelection();
  // if (ctx.activeTenantId) headers.set('X-Tenant-Id', ctx.activeTenantId);
  // if (ctx.activeEntityId) headers.set('X-Entity-Id', ctx.activeEntityId);
  // if (ctx.activeConfigId) headers.set('X-Config-Id', ctx.activeConfigId);  
  // If caller provided explicit headers, prefer those over localStorage.
  if (ctx.activeTenantId && !headers.has('X-Tenant-Id')) headers.set('X-Tenant-Id', ctx.activeTenantId);
  if (ctx.activeEntityId && !headers.has('X-Entity-Id')) headers.set('X-Entity-Id', ctx.activeEntityId);
  if (ctx.activeConfigId && !headers.has('X-Config-Id')) headers.set('X-Config-Id', ctx.activeConfigId);
  return headers;
}

export async function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const hadAuthAttempt = Boolean(readToken());
  const resp = await fetch(input, {
    ...(init ?? {}),
    headers: buildApiHeaders(init?.headers),
  });
  // Stale/expired JWT: list endpoint used to succeed without auth, so UI looked "logged in" while detail failed.
  if (resp.status === 401 && hadAuthAttempt) {
    notifySessionUnauthorized();
  }
  return resp;
}

